module.exports = __webpack_public_path__ + "static/media/Signup_background.c4ecdbaa.webp";